const MINUTES_PER_HOUR = 60;
const MINUTES_PER_DAY = 24 * MINUTES_PER_HOUR;

export const ONE_MONTH_MINUTES = 30 * MINUTES_PER_DAY;

type DurationParts = {
  days: number;
  hours: number;
  minutes: number;
};

function expirationMinutesToParts(totalMinutes: number): DurationParts {
  const days = Math.floor(totalMinutes / MINUTES_PER_DAY);
  const remainingMinutesAfterDays = totalMinutes % MINUTES_PER_DAY;
  const hours = Math.floor(remainingMinutesAfterDays / MINUTES_PER_HOUR);
  const minutes = remainingMinutesAfterDays % MINUTES_PER_HOUR;

  return { days, hours, minutes };
}

function pluralize(value: number, unit: string): string {
  return `${value} ${unit}${value === 1 ? '' : 's'}`;
}

export function formatExpirationMinutes(totalMinutes?: number): string {
  if (totalMinutes == null) {
    return 'Loading...';
  }

  const { days, hours, minutes } = expirationMinutesToParts(totalMinutes);
  const parts = [
    days > 0 ? pluralize(days, 'day') : null,
    hours > 0 ? pluralize(hours, 'hour') : null,
    minutes > 0 ? pluralize(minutes, 'minute') : null,
  ].filter(Boolean);

  return parts.length > 0 ? parts.join(', ') : '0 minutes';
}
